<div>
  <h3>{{item.translation_key||item.outcome_label || 'outcome'| translation|translationFromString | transformText :item?.text_transform}}</h3>
  <div class="flex-list">
    <div style="flex:1">
      <nb-form-field>
        <label>{{item.translation_key||item.outcome_label || 'outcome'| translation|translationFromString | transformText :item?.text_transform}} {{'verb'| translation}}</label>
        <input type="text" nbInput required [nbAutocomplete]="autoGroup" [(ngModel)]="_term" placeholder="{{item.outcome_label || 'Outcome'}} Verb" (input)="filterList()" fullWidth="true">
        <nb-autocomplete #autoGroup (selectedChange)="selectedVerb($event)">
          <nb-option-group *ngFor="let item of filterd" [title]="item.name">
            <nb-option *ngFor="let verb of item.terms" [value]="verb">
              {{verb}}
            </nb-option>
          </nb-option-group>
        </nb-autocomplete>
      </nb-form-field>
    </div>
    <!--  <div class="col-md-3">
      <div *ngIf="selectedLevel">
          <div>Blooms Level: {{selectedLevel.name}}</div>
          <p>{{selectedLevel.description}}</p>
        </div>
        <h3>Level (Bloom's Taxonomy)</h3>
  <div class="flex-list">
    <div style="flex:1">
      <mat-form-field style="width:100%;">
        <nb-select [(ngModel)]="level" placeholder="Impact Level" (selectedChange)="selectLevel(level)">
          <nb-option *ngFor="let item of outcomes.settings" [value]="item">{{item.name}}</nb-option>
        </nb-select>

      </mat-form-field>
    </div>
    <button nbButton ghost status="warning" (click)="selectLevel()" aria-label="Clear the verb selection">
      <i class="fas fa-ban"></i>

    </button>
  </div>
  <div *ngFor="let level of outcomes.settings | filter : 'name' : level">
    <p>{{level.description}}</p>

  </div>
    </div>-->
    <div style="flex:2">

      <nb-form-field>
        <label>{{item.translation_key||item.outcome_label || 'outcome'| translation}} {{'description'| translation|translationFromString | transformText :item?.text_transform}}</label>
        <textarea nbInput [(ngModel)]="text" placeholder="{{item.outcome_label || 'Outcome'}} Description" (input)="setValue('text', text)" fullWidth="true"></textarea>
      </nb-form-field>
    </div>
  </div>

</div>
